export function imprimeSiContieneCondicional(aguja, texto, salidaSiEncuentra, salidaSiNoEncuentra) {
  if (arguments.length < 4) {
    throw new Error('imprimeSiContieneCondicional requiere 4 parámetros')
  }

  const needle = aguja == null ? '' : String(aguja)
  if (!needle) {
    throw new Error('El parámetro aguja de imprimeSiContieneCondicional no puede estar vacío')
  }

  const baseText = Array.isArray(texto)
    ? texto.filter((v) => v != null && v !== '').join(' ')
    : texto
  const haystack = baseText == null ? '' : String(baseText)

  const n = needle.toLowerCase()
  const h = haystack.toLowerCase()

  return h.includes(n)
    ? (salidaSiEncuentra == null ? '' : String(salidaSiEncuentra))
    : (salidaSiNoEncuentra == null ? '' : String(salidaSiNoEncuentra))
}
